import db from ".";
import { Order } from "../app/models/Order";
import { converter2 } from "./converter";
import * as Log from "src/util/SDayslogger";

export const getOrderByID = async (id: string) => {
  return await db
    .collection("orders")
    .doc(id)
    .withConverter(converter2<Order>())
    .get()
    .then((doc) => {
      if (!doc || !doc.exists) {
        return undefined;
      }
      return { ...doc.data(), id: doc.id };
    })
    .catch((err) => {
      console.log(err);
      return undefined;
    });
};

export const updatePriorityNumber = async (id: string, newPrior: number) => {
  return await db.collection("orders").doc(id).update({
    orderPriorityNumber: newPrior,
  });
};
